import React from 'react';
import { Loader } from 'freemium-ui';
import { useLocation } from 'react-router-dom';
import { Center } from '../../../shared/styles';
import request from '../../../utils/request';

const useQueryParams = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const AccountInvite = () => {
  const query = useQueryParams();

  const activateUser = async (token: string) => {
    const response = await request(`/invite-accept/${token}`);
    if (response?.redirect_url) {
      // activation url received
      window.location.href = response.redirect_url;
    } else {
      // activation url not received
      const authToken = window.localStorage.getItem('authToken');
      if (authToken) {
        // first try logout the existing user if any
        const logoutResponse = await request('/logout', {}, 'POST');
        localStorage.clear();
        if (logoutResponse?.redirect_url) {
          window.location.href = logoutResponse.redirect_url;
        }
      } else {
        // reload the origin itself
        window.location.href = window.location.origin;
      }
    }
  };

  React.useEffect(() => {
    const token = query.get('token');
    if (token) activateUser(token);
  }, []);

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default AccountInvite;
